import React from "react";
import { NumericFormat } from "react-number-format";

const CustomInput = React.forwardRef((props, ref) => (
    <input ref={ref} {...props} />
));

const FormattedNumberInput = ({ value, onChange, ...rest }) => {
    return (
        <NumericFormat
            value={value}
            thousandSeparator=","
            allowNegative={false}
            decimalScale={8}
            customInput={CustomInput}
            onValueChange={(values) => {
                const { floatValue } = values;
                onChange(floatValue ?? "");
            }}
            {...rest}
        />
    );
};

export default FormattedNumberInput;
